<form [formGroup]="entityForm" novalidate class="d-flex flex-column gap-3">
  <h3>
    {{ 'entity.form' | translate }}
  </h3>
  <ap-field
    [title]="'entity.name' | translate"
    [required]="true"
    [error]="nameField.touched && !!nameField.errors">
    <input appkit-field formControlName="name" [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - nameField.value.length }
      }}
    </div>
    @if (nameField.touched && nameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (
      (nameField.touched || nameField.dirty) && nameField.errors?.['pattern']
    ) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.invalidTextBoxValue' | translate }}
      </div>
    }
  </ap-field>

  <gstar-residency-jurisdiction-combobox
    [required]="true"
    [value]="residencyJurisdictionValue"
    (selectResidencyJurisdiction)="selectResidencyJurisdiction($event)" />

  <gstar-entity-types-combobox
    [required]="true"
    [value]="entityTypeValue"
    [disabled]="disableEntityType"
    [onlyActives]="true"
    [hasSelectedJurisdiction]="hasSelectedJurisdiction()"
    (selectEntityType)="selectEntityType($event)" />

  @if (isEdit) {
    <ap-checkbox formControlName="isActive" class="mt-2">
      {{ 'manageEntities.active' | translate }}
    </ap-checkbox>
  }
</form>
